import React from 'react'

export function LoadingSpinner() {
  return (
    <div data-testid="loading" className="fixed inset-0 z-50 flex items-center justify-center bg-white/70">
      <div className="loadingSpinner" />
    </div>
  )
}
